/**
 * @flow
 * @relayHash 77d12343a905a6baf46d2aa4a5233265
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SubscribeToNewsletterInput = {|
  email: string,
  language: string,
  sport?: ?string,
|};
export type SubscribeToNewsletterMutationVariables = {|
  input: SubscribeToNewsletterInput
|};
export type SubscribeToNewsletterMutationResponse = {|
  +subscribeToNewsletter: ?{|
    +status: ?string
  |}
|};
export type SubscribeToNewsletterMutation = {|
  variables: SubscribeToNewsletterMutationVariables,
  response: SubscribeToNewsletterMutationResponse,
|};
*/


/*
mutation SubscribeToNewsletterMutation(
  $input: SubscribeToNewsletterInput!
) {
  subscribeToNewsletter(input: $input) {
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SubscribeToNewsletterInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "subscribeToNewsletter",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubscribeToNewsletterPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SubscribeToNewsletterMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SubscribeToNewsletterMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SubscribeToNewsletterMutation",
    "id": null,
    "text": "mutation SubscribeToNewsletterMutation(\n  $input: SubscribeToNewsletterInput!\n) {\n  subscribeToNewsletter(input: $input) {\n    status\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5598a90bd395e0a1d8c3e5b685291d58';

module.exports = node;
